<template>
  <b-collapse class="evaluation-card" animation="slide" :open="isOpen" data-cy="logs-data">
    <template #trigger="{ open }">
      <div class="card-header" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          Logs
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </div>
    </template>
    <div class="card-block">
      <ul class="is-size-7 logs">
        <li v-for="(error, key) in evaluation.reasonsError" :key="key">
          {{ error }}
        </li>
      </ul>
    </div>
  </b-collapse>
</template>
<script>
export default {
  name: 'LogsCard',
  props: {
    evaluation: {
      type: Object
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
h3{
  margin: 0 8px;
  display: inline-block;
  font-size: 1.25rem;
  font-weight: 500;
}
.panel{
  box-shadow: none;
}
.panel .panel-block{
  border: 1px solid #E9E9E9;
  border-radius: 10px;
}
#resume .panel.result {
  height: 100%;
}
#resume .panel .panel-block .commercial-purpose {
  font-size: 1.5rem;
  font-weight: 500;
}
#resume .approved {
  padding-bottom: 1.5rem;
}
#resume .explanations {
  padding-bottom: 1.5rem;
}
#resume .panel.result .panel-block{
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.collapse{
  margin-top: 1.5rem;
}
.collapse .panel-heading{
  margin-bottom: 0.1rem;
  background: transparent;
  padding: 0;
}
.collapse .panel-heading .collapse-icon{
  font-size: 0.8rem;
}
#resume .evaluation-card {
  box-shadow: none;
  margin-bottom: 1rem;
}

#resume ul.logs {
  list-style: disc;
  margin-left: 1rem;
}
@media screen and (min-width: 1024px) {
  .columns.is-desktop-reversed .column.is-8-desktop {
    order: -1;
  }
}
</style>
<style>
.evaluation-card .card-header {
  padding: 0.4rem 16px;
  border-radius: 10px;
  background: #F2F2F2;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.evaluation-card .card-header-title,
.evaluation-card .card-header-icon {
  padding: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4D4D4D;
}
</style>
